










































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, Collection} from 'simpli-web-sdk'
import {DivIcon, FeatureGroup, Icon, LatLngBounds, Map, Marker, TileLayer} from 'leaflet'
// @ts-ignore
import {MarkerClusterGroup, MarkerCluster} from 'leaflet.markercluster'
import {Getter} from 'vuex-class'
import moment from 'moment'
import {MapConfig} from '@/config/map.config'
import PosicaoMotorista from '@/model/resource/PosicaoMotorista'
import Responsavel from '@/model/resource/Responsavel'
import {GmapPosition} from '@/config/map.config'
import * as Helper from '@/helpers'

@Component
export default class MapTracking extends Vue {
  @Prop({type: Object, required: true}) collection!: Collection<PosicaoMotorista>
  @Prop({type: Object, default: null}) value!: PosicaoMotorista | null
  @Getter('auth/responsavel') user!: Responsavel

  uid: string | null = null

  map: Map | null = null

  cluster: FeatureGroup | null = null

  infoWindowOpened = false

  get input() {
    return this.value
  }

  set input(val) {
    this.$emit('input', val)
  }

  get deliveries() {
    return this.collection.items.length
  }

  get markers(): GmapPosition[] {
    return this.collection.items
      .filter((resource: PosicaoMotorista) => !!(resource.latitude && resource.longitude))
      .map((resource: PosicaoMotorista) => ({
          id: resource.idPosicaoPk,
          lat: resource.latitude || 0,
          lng: resource.longitude || 0,
          customTrack: resource.customTrack,
          hasCheckin: (resource.carga.dataCheckIn) || false,
          isLate: (resource.carga.dataPrevisao && moment().isAfter(moment(resource.carga.dataPrevisao))) || false,
      }))
  }

  getInfoWindowContent(resource: PosicaoMotorista, loading = false) {
    const driver = resource.motorista.$tag || ''
    const transporter = resource.carga.transportador.$tag || ''
    const license = resource.motorista.placaVeiculo || ''
    const addressee = resource.carga.destinatario.$tag || ''
    const shipper = resource.carga.embarcador.$tag || ''
    const nroNotafiscal = resource.carga.nroNotaFiscal || ''
    const lastUpdate = resource.data || ''
    const estimatedTime = resource.motorista.ultimaDuracaoParaDestinoFormatado || ''

    const dataCheckin = resource.carga.dataCheckIn || ''
    let formattedDataCheckin = ''

    const distanciaParaDestino = resource.distanciaParaDestinoKm || ''
    const dataPrevisao = resource.carga.dataPrevisao || ''
    let formattedDataPrevisao = ''

    if (dataCheckin) {
      formattedDataCheckin = moment(dataCheckin).format('DD/MM/YYYY HH:mm:ss') || ''
    }

    if (dataPrevisao) {
      formattedDataPrevisao = moment(dataPrevisao).format('DD/MM/YYYY HH:mm:ss') || ''
    }

    const trDriver = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.driver')}</td>
      <td class="py-5 tc-charcoal-grey">${driver}</td>
    </tr>`

    const trTransp = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.transporter')}</td>
      <td class="py-5 tc-charcoal-grey">${transporter}</td>
    </tr>`

    const trLicense = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.license')}</td>
      <td class="py-5 tc-charcoal-grey">${license}</td>
    </tr>`

    const trAddressee = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.addressee')}</td>
      <td class="py-5 tc-charcoal-grey">${addressee}</td>
    </tr>`

    const trShipper = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.shipper')}</td>
      <td class="py-5 tc-charcoal-grey">${shipper}</td>
    </tr>`

    const trNroFiscal = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.nroNotaFiscal')}</td>
      <td class="py-5 tc-charcoal-grey">${nroNotafiscal}</td>
    </tr>`

    const trDataCheckin = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.dataCheckIn')}</td>
      <td class="py-5 tc-charcoal-grey">${formattedDataCheckin}</td>
    </tr>`

    const trLastUpdate = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.lastUpdate')}</td>
      <td class="py-5 tc-charcoal-grey">${Helper.datetime(lastUpdate)}</td>
    </tr>`

    const trDataPrevisao = `<tr>
      <td class="py-5">${$.t('view.tracking.infoWindow.dataPrevisao')}</td>
      <td class="py-5 tc-charcoal-grey">${formattedDataPrevisao}</td>
    </tr>`

    let trDistanciaParaDestino = ''
    let trEstimatedTime = ''

    if (this.user.permitirRastreamentoDistancia) {
      if (loading) {
        trDistanciaParaDestino = `<tr>
          <td class="py-5">${$.t('view.tracking.infoWindow.distanciaParaDestino')}</td>
          <td class="py-5 tc-charcoal-grey">${$.t('view.tracking.infoWindow.loading')}</td>
        </tr>`

        trEstimatedTime = `<tr>
          <td class="py-5">${$.t('view.tracking.infoWindow.estimatedTime')}</td>
          <td class="py-5 tc-charcoal-grey">${$.t('view.tracking.infoWindow.loading')}</td>
        </tr>`
      } else {
        trDistanciaParaDestino = `<tr>
          <td class="py-5">${$.t('view.tracking.infoWindow.distanciaParaDestino')}</td>
          <td class="py-5 tc-charcoal-grey">${distanciaParaDestino ? distanciaParaDestino + 'km' : '-'}</td>
        </tr>`

        trEstimatedTime = `<tr>
          <td class="py-5">${$.t('view.tracking.infoWindow.estimatedTime')}</td>
          <td class="py-5 tc-charcoal-grey">${estimatedTime}</td>
        </tr>`
      }
    }

    return `
    <table>
      <tbody class="ff-light">
        ${trDriver}
        ${trTransp}
        ${trLicense}
        ${trAddressee}
        ${trShipper}
        ${trNroFiscal}
        ${trDataCheckin}
        ${trLastUpdate}
        ${trDistanciaParaDestino}
        ${trEstimatedTime}
        ${trDataPrevisao}
      </tbody>
    </table>`
  }

  async mounted() {
    // @ts-ignore
    this.uid = this._uid

    await this.$nextTick()

    const [lat, lng] = [MapConfig.defaultCenter.lat, MapConfig.defaultCenter.lng]

    this.map = new Map(`map${this.uid}`, {
      center: [lat, lng],
      zoom: 4,
      scrollWheelZoom: false,
      // @ts-ignore
      fullscreenControl: true,
      // @ts-ignore
      fullscreenControlOptions: {
        position: 'topleft',
      },
    }).on('dragstart', (e: any) => {
      const map: Map = e.sourceTarget
      map.closePopup()
    })
    // @ts-ignore
    new TileLayer(MapConfig.urlTemplate, MapConfig.tileLayerOptions).addTo(this.map)
  }

  @Watch('markers')
  @Watch('center')
  async markersEvent() {
    if (!this.map) return
    if (this.cluster) this.map.removeLayer(this.cluster)

    this.cluster = new MarkerClusterGroup({
      iconCreateFunction: (cluster: MarkerCluster) => new DivIcon({
        html: `<div class="it-cluster-text">${cluster.getChildCount()}</div>`,
        className: 'it-cluster',
        iconSize: [31, 41],
        iconAnchor: [16, 42],
      }),
    })

    const latlngs: Array<[number, number]> = []

    for (const marker of this.markers as any) {
      const CustomIcon = Icon.extend({
        options: {
          iconUrl: this.markerIcon(marker.hasCheckin, marker.customTrack, marker.isLate),
          iconSize: [24, 36],
          iconAnchor: [12, 34],
          popupAnchor: [0, -42],
        },
      })

      const [lat, lng] = [marker.lat, marker.lng]
      latlngs.push([lat, lng])

      const mapMarker = new Marker([lat, lng], {icon: new CustomIcon()})
        .on('click', (e) => this.selectEvent(marker.id, e.sourceTarget))
        .addTo(this.map)

      this.cluster.addLayer(mapMarker)
    }

    const bounds = new LatLngBounds(latlngs)

    this.map.addLayer(this.cluster)
    this.map.fitBounds(bounds, {maxZoom: 14})
  }

  async selectEvent(id: number, marker: Marker) {
    this.input = this.collection.items.find((it) => it.idPosicaoPk === id) || null
    await this.$nextTick()

    const resource = this.input
    if (!resource) return

    marker
      .bindPopup(this.getInfoWindowContent(resource, true), {maxWidth: 400, autoPanPadding: [50, 50]})
      .openPopup()

    const popup = marker.getPopup()
    if (popup) {
      popup.on('remove', () => {
        this.infoWindowOpened = false
      })
    }

    await this.updateDistancia(resource)
    await this.$nextTick()

    marker.setPopupContent(this.getInfoWindowContent(resource, false))
  }

  async updateDistancia(posicao: PosicaoMotorista | null) {
    if (posicao == null) return

    const updateDistanciaConditions = [
      this.user.permitirRastreamentoDistancia,
      !posicao.customTrack,
      !posicao.distanciaParaDestinoEmMetros || !posicao.duracaoParaDestinoEmSegundos,
      Boolean(posicao.carga.endereco || posicao.carga.destinatario.endereco),
    ]

    if (updateDistanciaConditions.includes(false)) return

    try {
      const {data} = await posicao.updateDistanceTo()

      if (data && this.value) {
        this.value.distanciaParaDestinoEmMetros = data.distanciaParaDestinoEmMetros
        this.value.duracaoParaDestinoEmSegundos = data.duracaoParaDestinoEmSegundos
        this.value.motorista.ultimaDistanciaParaDestinoEmMetros = data.distanciaParaDestinoEmMetros
        this.value.motorista.ultimaDuracaoParaDestinoEmSegundos = data.duracaoParaDestinoEmSegundos
      }
    } catch {
      // ignore error
    }
  }

  markerIcon(hasCheckin: boolean, customTrack: boolean, isLate: boolean) {
    if (customTrack) {
      return MapConfig.truckCustomIcon
    } else if (isLate) {
      return MapConfig.truckLateIcon
    }

    return (hasCheckin) ? MapConfig.truckWithCheckinIcon : MapConfig.truckIcon
  }
}
